import request from "./axios";
import moment from "moment-timezone";
const { CONFIG } = require("../../config");

const getTeams = (authParams, filter) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "POST",
    url: `${CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL}/v1/client/${clientId}/team-master-search`,
    data: filter,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

const getSlots = (authParams) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "GET",
    url: `${CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL}/v1/client/${clientId}/namespace/motiontrack/settings`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

const getAllGroups = (authParams, tourBody) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "POST",
    url: `${CONFIG.LOCUS.LILY_API?.[`LILY_PROD_BASE_URL_${clientId}`]}/v1/client/${clientId}/group`,
    data: tourBody,
    headers: { Authorization: `Bearer ${authToken}` },
  };
  return request(options);
};

export const getSession = ({ authToken, clientId }) => {
  const options = {
    method: "GET",
    baseURL: CONFIG.LOCUS?.[clientId]?.LOCUS_DASH_BASE_URL,
    url: `/session/me`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

export const createPaymentStatus = (reqBody, clientId, orderId, status) => {
  const options = {
    method: "POST",
    baseURL: CONFIG.LOCUS?.[clientId]?.LILY_PAYMENT_BASE_URL,
    url: `/v1/client/${clientId}/order-proxy/order/${orderId}/${status}?webPage=true`,
    headers: { Authorization: null },
    data: reqBody,
  };

  return request(options);
};

// Rider JWTs are not authorized for tour-search (neither the dashboard nor the
// LOTR rider variant -> ERROR_AUTHORIZATION_REQUIRED). The rider-authorized
// endpoint is the LOTR app's `alltours`, which returns the rider's tours and
// tasks for the shift date. The response shape differs from tour-search
// (top-level tours[] + tasks[]), so it is reshaped by `normalizeRiderTours`
// before `buildSummary` consumes it.
export const getRiderToursToday = ({ clientId, authToken }, riderId, dateOverride) => {
  const shiftDate = dateOverride || moment().tz(CONFIG.TIMEZONE).format("YYYY-MM-DD");
  const path = `/v1/client/${encodeURIComponent(clientId)}/user/${encodeURIComponent(riderId)}/alltours`;
  return request({
    method: "GET",
    baseURL: CONFIG.LOTR_BASE_URL,
    url: `${path}?shiftDate=${encodeURIComponent(shiftDate)}&include=TOUR_VISITS,TASKS,SEQUENCE,COUNTS`,
    headers: { Authorization: `Bearer ${authToken}` },
  });
};

export const apiService = {
  getTeams,
  getAllGroups,
  getSlots,
  getSession,
};
